import { createStore } from 'hox';
import { useState } from 'react';
import { RolePermissionEnum } from '@Types/permissions';
import { PermissionValueEnum } from '@Types/administrator';

export const [useRoleDefinitionStore, RoleDefinitionProvider] = createStore(
  () => {
    const [rolePermission, setRolePermission] = useState({
      [RolePermissionEnum.dashboard]: PermissionValueEnum.ViewOnly,
      [RolePermissionEnum.atpPolicy]: PermissionValueEnum.ViewOnly,
      [RolePermissionEnum.dlpPolicy]: PermissionValueEnum.ViewOnly,
      [RolePermissionEnum.logReport]: PermissionValueEnum.ViewOnly,
      [RolePermissionEnum.quarantine]: PermissionValueEnum.ViewOnly,
    });
    const [orgManagementIds, setOrgManagementIds] = useState<string[] | 'all'>(
      []
    );
    const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);

    return {
      rolePermission,
      setRolePermission,
      orgManagementIds,
      setOrgManagementIds,
      errorMsg,
      setErrorMsg,
    };
  }
);
